import map from 'lodash/map';
import createPromiseThunk from "~/rx/lib/createPromiseThunk";
import {getAllSearchResultParams} from "~/stateGetter";
import createReduceResults from "~/rx/lib/reduceResults";
import fetchManyResults from "~/backend/fetchManyResults";

const search = createPromiseThunk({
    func: async ({dispatch, getConfig, getState, modelNames, cancelTokens}) => {
        let state = getState();

        let requestOptionsArray = map(modelNames, (modelName) => {
            return {
                modelName,
                params: getAllSearchResultParams(state, modelName),
                cancel: cancelTokens[modelName]
            }
        });

        return fetchManyResults(getConfig().baseUrl, requestOptionsArray);

    },
    name: 'search'
});

let execute = search.execute;
search.execute =  (modelNames, cancelTokens) => execute({modelNames, cancelTokens}, {searchModelNames: modelNames});
search.reduce = createReduceResults({
    promiseThunk: search,
    getParams: (results, state, searchModel) => getAllSearchResultParams(state, searchModel.modelName),
    reduceOriginal: search.reduce
});

const reduceSearchResults = search.reduce,
    SEARCH_DATA_TYPES = search.types,
    fetchSearchResults = search.execute;

export { reduceSearchResults, SEARCH_DATA_TYPES, fetchSearchResults };